import axios from 'axios';
import moment from 'moment';

export default {
    namespaced: true,

    state: {
        enterableTournaments: [],
        loadingEnterablesTournaments: false,
        loadingErrorEnterablesTournaments: null,

        enteringTournament: false,
        enteringTournamentError: null,
    },

    getters: {
        enterableTournaments: (state) => state.enterableTournaments,
        loadingEnterablesTournaments: (state) => state.loadingEnterablesTournaments,
        loadingErrorEnterablesTournaments: (state) => state.loadingErrorEnterablesTournaments,

        enteringTournament: (state) => state.enteringTournament,
        enteringTournamentError: (state) => state.enteringTournamentError,
    },

    mutations: {
        setEnterableTournaments(state, data) { state.enterableTournaments = data },

        startLoadingEnterablesTournaments(state) { state.loadingEnterablesTournaments = true; },
        startEnteringTournament(state) { state.enteringTournament = true; },

        stopLoadingEnterablesTournaments(state) { state.loadingEnterablesTournaments = false; },
        stopEnteringTournament(state) { state.enteringTournament = false; },

        setLoadingErrorEnterablesTournaments(state, error) { state.loadingErrorEnterablesTournaments = error; },
        setEnteringTournamentError(state, error) { state.loadingErrorEnterablesTournaments = error; },

        clearLoadingErrornterablesTournaments(state) { state.loadingErrorEnterablesTournaments = null; },
        clearEnteringTournamentError(state) { state.loadingErrorEnterablesTournaments = null; },

        setPartnerForTournament(state, data) {
            if (state.enterableTournaments.length > data.rowIndex) {
                state.enterableTournaments[data.rowIndex].partnerNbr = data.partnerNbr;
                state.enterableTournaments[data.rowIndex].partnerName = data.partnerName;
                state.enterableTournaments[data.rowIndex].canPartnerEnter = data.canPartnerEnter;
                state.enterableTournaments[data.rowIndex].partnerDenialCause = data.partnerDenialCause;
            }
        },
    },

    actions: {
        async getTournamentsByTournamentIncludingGs(context, options = {}) {
            context.commit('startLoadingEnterablesTournaments');
            context.commit('clearLoadingErrornterablesTournaments');
            try {
                var result = await axios.get(`${HOST_NAME}/api/DoublesEntry/TournamentsByTournamentIncludingGs/${options.tournYear}/${options.tournNbr}/${options.playerNbr}`);
                context.commit('setEnterableTournaments', result.data);
                context.commit('stopLoadingEnterablesTournaments');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setLoadingErrorEnterablesTournaments', error);
                context.commit('stopLoadingEnterablesTournaments');
                return Promise.reject(error);
            }
        },
        async getTournamentsByDeadlineIncludingGs(context, options = {}) {
            context.commit('startLoadingEnterablesTournaments');
            context.commit('clearLoadingErrornterablesTournaments');
            try {
                var result = await axios.get(`${HOST_NAME}/api/DoublesEntry/TournamentsByDeadlineIncludingGs/${options.deadline}/${options.playerNbr}`);
                context.commit('setEnterableTournaments', result.data);
                context.commit('stopLoadingEnterablesTournaments');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setLoadingErrorEnterablesTournaments', error);
                context.commit('stopLoadingEnterablesTournaments');
                return Promise.reject(error);
            }
        },
        async getTournament(context, options = {}) {
            context.commit('startLoadingEnterablesTournaments');
            context.commit('clearLoadingErrornterablesTournaments');
            try {
                var result = await axios.get(`${HOST_NAME}/api/Edition/${options.tournYear}/${options.tournNbr}`);
                result.data.canPlayerEnterThisTournament = true;
                context.commit('setEnterableTournaments', [result.data]);
                context.commit('stopLoadingEnterablesTournaments');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setLoadingErrorEnterablesTournaments', error);
                context.commit('stopLoadingEnterablesTournaments');
                return Promise.reject(error);
            }
        },
        async enterTournament(context, options = {}) {
            context.commit('startEnteringTournament');
            context.commit('clearEnteringTournamentError');
            try {
                var result = await axios.post(`${HOST_NAME}/api/DoublesEntry/EnterTournament`, options);
                context.commit('stopEnteringTournament');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setEnteringTournamentError', error);
                context.commit('stopEnteringTournament');
                return Promise.reject(error);
            }
        },
        setPartnerForTournament(context, data) {
            context.commit('setPartnerForTournament', data);
        },
        clearEnterableTournaments(context) {
            context.commit('setEnterableTournaments', []);
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/doubles/enterable-tournaments.js